import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'
import { CorporateAdminDashboard } from '../Actions'
import {
  GET_CORPORATE_BRANCH_TOTAL_DETAILS_ACTION,
  GET_CORPORATE_BRANCH_PERFORMANCE_ACTION,
  GET_CORPORATE_BRANCH_EXPENDITURE_ACTION,
} from '../constants/action-types'

const initialState = {
  isLoading: false,
  errorMessage: '',
  branchTotalDetails: {},
  branchPerformance: [],
  branchExpenditure: [],
  branchTotalDetailsLoader: false,
  branchPerformanceLoader: false,
  branchExpenditureLoader: false,
}

const reducer = persistReducer(
  { storage, key: 'corporate-dashboard', whitelist: [] },
  (state: CorporateAdminDashboard = initialState, action: ActionTypes) => {
    switch (action.type) {
      //For branch total details
      case GET_CORPORATE_BRANCH_TOTAL_DETAILS_ACTION.GET_CORPORATE_BRANCH_TOTAL_DETAILS_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          branchTotalDetailsLoader: true,
        }

      case GET_CORPORATE_BRANCH_TOTAL_DETAILS_ACTION.GET_CORPORATE_BRANCH_TOTAL_DETAILS_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          branchTotalDetailsLoader: false,
          branchTotalDetails: action.payload as any,
        }

      case GET_CORPORATE_BRANCH_TOTAL_DETAILS_ACTION.GET_CORPORATE_BRANCH_TOTAL_DETAILS_FAILED:
        return {
          ...state,
          errorMessage: '',
          branchTotalDetailsLoader: false,
        }

      //For branch performance overview
      case GET_CORPORATE_BRANCH_PERFORMANCE_ACTION.GET_CORPORATE_BRANCH_PERFORMANCE_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          branchPerformanceLoader: true,
        }

      case GET_CORPORATE_BRANCH_PERFORMANCE_ACTION.GET_CORPORATE_BRANCH_PERFORMANCE_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          branchPerformanceLoader: false,
          branchPerformance: action.payload as any,
        }

      case GET_CORPORATE_BRANCH_PERFORMANCE_ACTION.GET_CORPORATE_BRANCH_PERFORMANCE_FAILED:
        return {
          ...state,
          errorMessage: '',
          branchPerformanceLoader: false,
        }

      //For branch expenditure overview
      case GET_CORPORATE_BRANCH_EXPENDITURE_ACTION.GET_CORPORATE_BRANCH_EXPENDITURE_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          branchPerformanceLoader: true,
        }

      case GET_CORPORATE_BRANCH_EXPENDITURE_ACTION.GET_CORPORATE_BRANCH_EXPENDITURE_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          branchPerformanceLoader: false,
          branchExpenditure: action.payload as any,
        }

      case GET_CORPORATE_BRANCH_EXPENDITURE_ACTION.GET_CORPORATE_BRANCH_EXPENDITURE_FAILED:
        return {
          ...state,
          errorMessage: '',
          branchExpenditureLoader: false,
        }
      default:
        return state
    }
  }
)

export default reducer
